﻿import React, { useEffect, useState } from 'react';
import { Input, Collapse, Icon } from 'antd';
import {
  FilterWidget,
  FormInput,
  FormSelect,
  FormSubmitButton,
  GridView,
  MasterDetailForm,
  Widget,
  Button,
  useRouter,
  CompositeView,
} from '@digital/ui';

import { getAllAreasOptions } from '@app/api/area';
import {
  getMinutasbyFilter,
  getAllMinutaSimplificado,
  getAllStatusMinutaOptions,
  downloadArquivoMinuta,
} from '@app/api/minuta/Minutas';
import { InputLabel } from '@app/components';

import { EStatusCodigoMinuta } from '@app/enums/EStatusCodigoMinuta';
import { getAllDepartamentoOptions } from '@app/api/departamento';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { IMinuta, IMinutaFilter, IMinutaSimplificado } from '@app/models/MinutaModels';

const Minutas = () => {
  const { history } = useRouter();

  const [minutas, setMinutas] = useState<IMinutaSimplificado[]>([]);

  const initListMinutas = async () => {
    const minutasApi = await getAllMinutaSimplificado();
    if (minutasApi) {
      setMinutas(minutasApi);
    }
  };

  useEffect(() => {
    initListMinutas();
  }, []);

  const handleSearchFilter = async (values: IMinutaFilter) => {
    var resultado = (await getMinutasbyFilter(values)) || [];

    setMinutas(resultado);
  };

  const renderActionsWidgetPanel = (codigoStatusDaMinuta = 1, minuta: IMinutaSimplificado) => {
    const actions: any = [];

    const minutaId = minuta.id;

    if (EStatusCodigoMinuta['Em Customizacao'] === codigoStatusDaMinuta) {
      actions.push(
        <Button
          key="customizar"
          icon="editing-pencil"
          type="primary"
          style={{ float: 'right' }}
          onClick={() => {
            history.push(`./minutas/customizacaoDaMinuta?id=${minutaId}`);
            // window.location.href = `/customizacao/${minuta.id}`;
          }}>
          CUSTOMIZAR
        </Button>,
      );
    }

    if (EStatusCodigoMinuta['Customizada'] === codigoStatusDaMinuta) {
      actions.push(
        <Button
          key="preencher"
          icon="editing-pencil"
          type="primary"
          style={{ float: 'right' }}
          onClick={() => {
            history.push(`./minutas/preencherMinuta?id=${minutaId}`);
            // window.location.href = `/customizacao/${minuta.id}`;
          }}>
          PREENCHER
        </Button>,
      );
    }

    if (EStatusCodigoMinuta['Gerada'] === codigoStatusDaMinuta) {
      actions.push(
        <Button
          key="download-minuta"
          icon="ui-download"
          type="primary"
          style={{ float: 'right' }}
          onClick={async () => {
            await downloadArquivoMinuta(
              minutaId,
              'Minuta-' + (minuta.demandaIdentificadorTexto) + '.docx',
            );
          }}>
          DOWNLOAD
        </Button>,
      );
    }

    return actions;
  };

  return (
    <CompositeView>
      <GridView noform>
        <MasterDetailForm onSubmit={handleSearchFilter}>
          <FilterWidget
            title="FILTROS"
            actions={[
              <FormSubmitButton type="primary" icon={'commons-search'}>
                Pesquisar
              </FormSubmitButton>,
            ]}>
            <FormInput label="Número da demanda" name="numeroDaDemanda" span={4} />

            <FormInput label="Descrição da minuta" name="descricaoDaMinuta" span={4} />

            <FormSelect
              mode="multiple"
              label="Diretoria"
              name="diretorias"
              getOptions={getAllDiretoriasOptions}
              span={4}
            />
            <FormSelect
              mode="multiple"
              label="Área Solicitante"
              name="areasSolicidantes"
              getOptions={getAllAreasOptions}
              span={4}
            />

            <FormSelect
              mode="multiple"
              label="Departamento"
              name="departamentos"
              getOptions={getAllDepartamentoOptions}
              span={4}
            />

            <FormSelect
              mode="multiple"
              getOptions={getAllStatusMinutaOptions}
              label="Status"
              name="statusDaMinuta"
              span={4}
            />
          </FilterWidget>
        </MasterDetailForm>

        <>
          {minutas && minutas.length > 0 ? (
            <>
              {minutas.map(minuta => {
                return (
                  <Collapse key={`${minuta.id}`} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                    <Collapse.Panel
                      key={`${minuta.id}`}
                      header={`${minuta.demandaIdentificadorTexto}${
                        EStatusCodigoMinuta['Em Customizacao'] !== (minuta.minutaStatusCodigo)
                          ? ' - ' + minuta.descricao
                          : ''
                      }`}>
                      <Widget
                        actions={renderActionsWidgetPanel(minuta.minutaStatusCodigo, minuta)}>
                        <InputLabel label="Número da demanda" span={4}>
                          <Input value={minuta.demandaIdentificadorTexto} readOnly />
                        </InputLabel>

                        {EStatusCodigoMinuta['Em Customizacao'] !==
                          (minuta.minutaStatusCodigo) && (
                          <InputLabel label="Descrição da minuta" span={4}>
                            <Input value={minuta.descricao} readOnly />
                          </InputLabel>
                        )}

                        {minuta.minutaDiretoriaNome && (
                          <InputLabel label="Diretoria" span={4}>
                            <Input name="diretoria" value={minuta.minutaDiretoriaNome} readOnly={true} />
                          </InputLabel>
                        )}

                        {minuta.minutaAreaNome && (
                          <InputLabel label="Área Solicitante" span={4}>
                            <Input name="inputAreaSolicitante" value={minuta.minutaAreaNome} readOnly={true} />
                          </InputLabel>
                        )}

                        {minuta.minutaDepartamentoNome && (
                          <InputLabel label="Departamento" span={4}>
                            <Input name="departamento" value={minuta.minutaDepartamentoNome} readOnly={true} />
                          </InputLabel>
                        )}

                        <InputLabel label="Status" span={4}>
                          <Input value={minuta.minutaStatusNome} readOnly />
                        </InputLabel>
                      </Widget>
                    </Collapse.Panel>
                  </Collapse>
                );
              })}
            </>
          ) : (
            <></>
          )}
        </>
      </GridView>
    </CompositeView>
  );
};

export default Minutas;
